module.exports = __webpack_public_path__ + "static/media/magnify-icon_2x.04346d57.png";